<template>
    <div>
      <mt-header fixed :title="title" class="head" >
         <router-link to="/imgupdate" slot="left">
          <mt-button icon='back'></mt-button>
         </router-link>
        <mt-button slot="right" v-show="auth.editable" @click="commit">提交</mt-button>
      </mt-header>
      <div class="procedure">
        <div class="procedure-group">
          <div class="procedure-title">瓷砖缝隙 ({{img_check_1.length}}/3)</div>
          <div class="procedure-content">
            <div class="c_rela procedure-img" v-for="(n,index) in img_check_1" :key="index" v-if="index<imgNum.img_check_1">
              <div class="imgdel" v-show="auth.editable" @click="delClick('img_check_1',index)">×</div>
              <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
            </div>
            <update-file v-show="(img_check_1.length<imgNum.img_check_1) && auth.editable" @fileChange="getUrl($event,'img_check_1')"></update-file>
          </div>
          <div class="procedure-memo">
            <div>备注：填缝饱满</div>
          </div>
        </div>
        <div class="c_hide procedure-group">
          <div class="procedure-title">堵漏宝增强&nbsp;&nbsp;({{img_check_2.length}}/3)</div>
          <div class="procedure-content">
            <div class="c_rela procedure-img" v-for="(n,index) in img_check_2" :key="index" v-if="index<3">
              <div class="imgdel" v-show="auth.editable" @click="delClick('img_check_2',index)">×</div>
              <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
            </div>
            <update-file v-show="(img_check_2.length<3) && auth.editable" @fileChange="getUrl($event,'img_check_2')"></update-file>
          </div>
          <div class="procedure-memo">
            <div>备注：地漏管根、过门石</div>
          </div>
        </div>

        <div class="procedure-group">
          <div class="procedure-title">备注</div>
          <div class="procedure-content" :class="auth.editable?'':'c_no_pointer'">
            <textarea v-model="memo" placeholder="备注" cols="30" rows="10" @change="autoSave('memo',memo)"></textarea>
          </div>
        </div>
      </div>
      <!--图片显示-->
      <c-imgshow @part_close="part_close" :ispart_imgshow="ispart_imgshow" :imgshow_url="imgshow_url">
      </c-imgshow>
    </div>
</template>
<script>
import axios from 'axios'
import {Indicator, MessageBox} from 'mint-ui';
import UpdateFile from './update-file';
import CImgshow from './c-imgshow';
export default {
    components:{UpdateFile,CImgshow},
    data(){
        return{
          qiniu:this.$$api.mobile.qiniuDownload,
          // qiniu:'',//???????
            img_check_1:[],
            img_check_2:[],
            img_check_3:[],
            sid:'',
            formid:'',
            title:'',
            memo:'',
            // 图片显示
            ispart_imgshow:false,
            imgshow_url:'',
            imgNum:{
              img_check_1:3
            },
            // 权限控制
            auth:{
              //是否开启自动保存
              isAutoSave:false,
              //是否有提交权限
              editable:false,
              // editable:true,//???????
              //是否 -- 可以提交
              isCommit:true,
            },
        }
    },
    mounted(){
      var obj = JSON.parse(localStorage['obj']);
      var procedure = obj.procedure;
      this.sid = procedure.billbid;
      this.formid = procedure.formid;
      this.itemid = procedure.itemid;
      this.title = procedure.itemname;
      this.load();
      this.getAuth();
    },
    methods:{
      // 获取工序详情
      load:function(){
        var $that = this;
        this.$ajax.get(this.$$api.mobile.getProcedureDetail,{
          'sid':this.sid,
          'formid':this.formid
        },function (res) {
          if(res.status ==200) {
            var obj = res.data.detailMsg.data;
            $that.img_check_1 = obj.img_check_1 ? (obj.img_check_1.split(',')||[]):[];
            $that.img_check_2 = obj.img_check_2 ? (obj.img_check_2.split(',')||[]):[];
            $that.img_check_3 = obj.img_check_3 ? (obj.img_check_3.split(',')||[]):[];
            $that.memo = obj.memo;
          }
          setTimeout(function(){
            $that.auth.isAutoSave = true;
          },500);
        });
      },
      // 获取当前用户权限
      getAuth:function(){
        var $that = this;
        this.$ajax.get(this.$$api.mobile.getProcedureAuth,{
          'itemid':this.itemid,
          'billbid':this.sid,
        },function (res) {
          if(res.status ==200) {
            var obj = res.data.detailMsg.data;
            $that.auth.editable = obj.editable == 'Y'? true:false;
          }
        });
      },
      autoSave(type,value){
        if(type && this.sid &&this.formid && this.auth.isAutoSave) {
          this.$ajax.get(this.$$api.mobile.saveProcedure, {
            'sid':this.sid,
            'formid':this.formid,
            'attribute':type,
            'value':value
          },response=>{
            if (response.status >= 200 && response.status < 300) {
              // console.log(response);
            } else {
              // console.log(response,this.sid);
            }
          });
        }
      },
      getUrl(e,val){
        var $that = this;
        // var file = e.files[0];
        var file = this.$comm.toBase64(e.base64);
        if(val=='img_check_1'){
          this.imgFile('img_check_1',file,function (url) {
            $that.img_check_1.push(url);
          });
          Indicator.close();
        }else if(val=='img_check_2'){
          this.imgFile('img_check_2',file,function (url) {
            $that.img_check_2.push(url);
          });
          Indicator.close();
        }else if(val=='img_check_3'){
          this.imgFile('img_check_3',file,function (url) {
            $that.img_check_3.push(url);
          });
          Indicator.close();
        }
      },
      // 上传图片
      imgFile:function(type,file,fun){
        var $that = this;
        $that.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getimgtoken,{},function (res) {
          if(res.status == 200){
            var token = res.data.token;
            var fileid = res.data.fileid;
            let param = new FormData(); //创建form对象
            // param.append('file',file,file.name);//通过append向form对象添加数据
            param.append('file',file, Date.now() + '.jpg');
            param.append('chunk','0');//添加form表单中其他数据
            param.append('token',token);//添加form表单中其他数据
            param.append('key',fileid);//添加form表单中其他数据
            let config = {
              headers:{'Content-Type':'multipart/form-data'}
            };
            axios.post($that.$$api.mobile.qiniuUpload,param,config)
              .then(data=>{
                var key = data.data.key;
                if(fun)fun(key);
                $that.$indicator.close();
              });
          }
        });

      },
      // 删除图片
      delClick:function(type,index){
        if(type == 'img_check_1'){
          var arr = this.img_check_1;
          arr.splice(index,1);
          this.img_check_1 = arr;
        }else if(type == 'img_check_2'){
          var arr = this.img_check_2;
          arr.splice(index,1);
          this.img_check_2 = arr;
        }else if(type == 'img_check_3'){
          var arr = this.img_check_3;
          arr.splice(index,1);
          this.img_check_3 = arr;
        }
      },
      commit:function () {
        var $that = this;
        // if(this.img_check_1.length < this.imgNum.img_check_1){ this.$toast("请上传最少"+this.imgNum.img_check_1+"张检查点图片");return;}
        // if(this.img_check_2.length <3){ this.$toast("请上传最少三张检查点2图片");return;}
        // if(this.img_check_3.length <3){ this.$toast("请上传最少三张检查点3图片");return;}
        if(!this.auth.isCommit){return;}
        this.auth.isCommit = false;
        this.auth.editable = false;
        this.$ajax.post(this.$$api.mobile.commitProcedure,{
          'sid':this.sid,
          'formid':this.formid,
        },function (res) {
          $that.$router.push('/imgupdate');
        },function () {
          $that.auth.isCommit = true;
          $that.auth.editable = true;
        });
      },
      // 图片预览
      imgShowClick:function (e) {
        var url = e.currentTarget.dataset.src;
        if(url){
          this.imgshow_url = url;
          this.ispart_imgshow = true;
        }
      },
      part_close:function (value) {
        this.ispart_imgshow = value;
      },
    },
    watch:{
      img_check_1(){
        this.autoSave('img_check_1',(this.img_check_1).join(','));
      },
      img_check_2(){
        this.autoSave('img_check_2',(this.img_check_2).join(','));
      },
      img_check_3(){
        this.autoSave('img_check_3',(this.img_check_3).join(','));
      },
    }
}
</script>
<style scoped>

</style>





// WEBPACK FOOTER //
// src/components/newstep-9-8.vue